import { anatomiaLogic } from './anatomia.logic';
import { AnatomiaHost, AnatomiaProjector, AnatomiaStudent } from '../eval-blocks/DictadoAnatomiaViews';
import type { ActivityPlugin } from '../../core/types/activity.types';
import { GAME_MODE_CATALOG } from '../../core/types/gameMode.types';

export const anatomiaPlugin: ActivityPlugin<'anatomia'> = {
  ...anatomiaLogic,
  displayName: GAME_MODE_CATALOG.anatomia.displayName,
  icon: GAME_MODE_CATALOG.anatomia.icon,
  HostView: AnatomiaHost,
  StudentView: AnatomiaStudent,
  ProjectorView: AnatomiaProjector,
};

export { demoAnatomiaPayload } from './anatomia.logic';
